const areaRouter = [
    {
        path: "list-areas",
        name: "area",
        component: () => import("@/views/admin/area"),
        default: true,
        meta: {
            model: "area",
            // requiresAuth: true,
        },
    },
    {
        path: "list-areas/add",
        name: "addArea",
        component: () => import("@/views/admin/area/function"),
        default: true,
        meta: {
            model: "area",
            // requiresAuth: true,
        },
    },
    {
        path: "list-areas/edit/:id",
        name: "editArea",
        component: () => import("@/views/admin/area/function"),
        default: true,
        meta: {
            model: "area",
            // requiresAuth: true,
        },
    }
]
export default areaRouter;